import editCurriculumModalEn from "./locales/en.json";

export const EDIT_CURRICULUM_MODAL_NS = "editCurriculumModal" as const;

export const EditCurriculumModalTranslations = {
  en: {
    [EDIT_CURRICULUM_MODAL_NS]: {
      ...editCurriculumModalEn,
    },
  },
};
